import React, { useMemo, useEffect, useContext, useState, useRef } from 'react'
import ReactDOM from 'react-dom'
import { Polyline, InfoWindow } from '@react-google-maps/api'
import { DashboardContext } from 'live/context/dashboard'
import TripsContext from '../../contexts/TripsContext'

import InfoWindow1 from '../InfoWindow/InfoWindow1/InfoWindow1'
import { sort, getCarStatusStyle } from '../../utils'
import MarkersTrips from '../MarkersTrips'

import i18n from 'live/services/i18n'
import moment from 'moment'
import styled from 'styled-components'
import { createPopupHoverTrip } from '../../infowindow-utils'

const options = {
    strokeColor: '#878f9f',
    strokeOpacity: 0.9,
    strokeWeight: 4,
    visible: true,
    geodesic: true
}

const optionsTripActive = {
    strokeColor: '#37A3EF',
    strokeOpacity: 0.5,
    strokeWeight: 11,
    visible: true,
    zIndex: 2,
    geodesic: true
}

const sortTrips = (trips = []) => {
    let tripsSorted = []
    sort('end', trips).forEach(({ wayPoints }) => {
        tripsSorted = [...tripsSorted, ...wayPoints]
    })

    return tripsSorted
}

const PolylinesTrips = () => {
    const { isNavegateToTrips, trips, tripActive, setTrips, setTripActive, setInfoWindow } = useContext(TripsContext)
    const [polylineTrips, setPolylineTrips] = useState({ path: [] })
    const [polylineActive, setPolylineActive] = useState({ path: [] })

    const context: any = useContext(DashboardContext)

    useEffect(() => {
        setTripActive(undefined)
    }, [context])

    useEffect(() => {
        if (isNavegateToTrips === undefined) {
            setTrips([])
            setTripActive(undefined)
        }
    }, [isNavegateToTrips])

    useEffect(() => {
        setPolylineTrips({ path: sortTrips(trips) })
    }, [trips])

    useEffect(() => {
        setPolylineActive({ path: tripActive?.wayPoints || [] })
    }, [tripActive])

    const getPoint = (latLng, wayPoints) => {
        let min = 1000000
        let pointAux

        wayPoints.forEach(point => {
            const { lat, lng } = point
            const aux = new google.maps.LatLng({ lat, lng })
            const distance = google.maps.geometry.spherical.computeDistanceBetween(latLng, aux)

            if (distance < min) {
                min = distance
                pointAux = point
            }
        })

        return pointAux
    }

    const drawWindowCustom = event => {
        const waypoint = getPoint(event.latLng, tripActive.wayPoints)
        const popup = createPopupHoverTrip(event, waypoint)
        setInfoWindow(popup)
    }

    return (
        <>
            <MarkersTrips />

            <Polyline onLoad={() => { }} path={polylineTrips.path} options={options} />

            <Polyline
                onLoad={() => { }}
                path={polylineActive.path}
                options={optionsTripActive}
                onMouseMove={drawWindowCustom}
                onMouseOut={() => setInfoWindow(undefined)}
            />
        </>
    )
}

export default React.memo(PolylinesTrips)
